// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CountBox_wrapper__3s5j9","title":"CountBox_title__2KuOr","count":"CountBox_count__ucPTS","tip":"CountBox_tip__21CmQ","icon":"CountBox_icon__NY1BO"};